module.exports = __webpack_public_path__ + "static/media/_balearic-islands.999fa777.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_balearic-islands.svg
// module id = 2302
// module chunks = 7